// FAQ data. Used on home + condition pages.

export const FAQS = [
  {
    q: "Does acupuncture hurt?",
    a: "Almost never. The needles are about as thin as a strand of hair — many clients don't feel insertion at all. What you may feel is a soft heaviness, warmth, or a gentle ache where qi gathers around the point. Most people leave the table relaxed enough that they don't want to drive home immediately.",
  },
  {
    q: "Do you accept my insurance?",
    a: "I accept out-of-network benefits for 1199 SEIU, Aetna, Anthem, Blue Cross Blue Shield, SEIU, and United Healthcare. Coverage varies by plan — we'll check your benefits before your first session so there are no surprises. If you have any questions about insurance, feel free to ask. If your insurance isn't on this list, text or email me (929.272.6066 · sanoacu@gmail.com) and we'll see what we can do.",
  },
  {
    q: "What should I wear and bring?",
    a: "Loose, comfortable clothing so we can access arms, lower legs, and the abdomen if needed. Bring a list of any medications and supplements, and recent labs if you have them — they help me build the most accurate treatment plan.",
  },
  {
    q: "How many sessions will I need?",
    a: "It depends entirely on what you're working with. Acute pain or stress can shift in 2–3 sessions. Chronic patterns (hormones, sleep, fertility, migraines) typically need 6–12 weekly sessions before tapering. We'll set a clear plan after your first visit — no open-ended commitments.",
  },
  {
    q: "Is acupuncture safe?",
    a: "When performed by a licensed acupuncturist, acupuncture is one of the safest treatments in medicine. I use single-use, sterile, FDA-approved needles. Side effects are rare and mild (slight bruising at most). I'm licensed by New York State and trained in trauma-informed care.",
  },
  {
    q: "Can I come if I'm pregnant?",
    a: "Yes — and many do. Acupuncture is safe and supportive throughout pregnancy for nausea, fatigue, back pain, anxiety, and birth preparation. I'll always tell you which points we avoid and why.",
  },
  {
    q: "What is the difference between acupuncture and facial acupuncture?",
    a: "Body acupuncture treats internal patterns — pain, hormones, sleep, digestion. Facial acupuncture is restorative — fine needles into facial muscles trigger collagen and elastin production, soften fine lines, and release the jaw and brow tension we carry there. I always include body points in facial sessions because the face reflects what the body holds.",
  },
  {
    q: "How do I book my first appointment?",
    a: "Click any Book button on this site to choose a time on my calendar. Or call 929.272.6066 for a free phone consultation if you'd like to talk first about whether acupuncture is right for what you're working with.",
  },
];
